//<!------ Read More Button On Collection Page JS Start ------>

document.addEventListener("DOMContentLoaded", function () {
  let toggleButton = document.querySelector(".description-toggle-btton .toggle-button");
  let content = document.querySelector(".additional-collection-description.rte");

  toggleButton.addEventListener("click", function () {
    if (content) {
      content.classList.toggle("expanded");
      toggleButton.textContent = content.classList.contains("expanded") ? "Read Less" : "Read More";
    }
  });
});

//<!------ Read More Button On Collection Page JS End ------>

//<!------ Read More Button On Product Page JS Start ------>

document.addEventListener("DOMContentLoaded", function () {
  let toggleButton = document.querySelector(".description-toggle-btton .toggle-button");
  let content = document.querySelector(".additional-product-description.rte");

  toggleButton.addEventListener("click", function () {
    if (content) {
      content.classList.toggle("expanded");
      toggleButton.textContent = content.classList.contains("expanded") ? "Read Less" : "Read More";
    }
  });
});

//<!------ Read More Button On Product Page JS End ------>